<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-8">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <div class="box">
            <h1 class="has-text-weight-semibold is-size-4">Change password</h1>
            <p class="pb-2">
              Enter your current password in order to change it to a new one
            </p>
            <ValidationProvider
              slim
              rules="required"
              name="Old Password"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="Current password"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="[
                  errors[0],
                  'The password should be minimum <b>six characters</b> length, contain <b>one capital letter</b> and <b>one number</b> (+ an elfic character from an old spell book)',
                ]"
              >
                <b-input
                  v-model="passwords.old_password"
                  type="password"
                  autocomplete="current-password"
                  name="current-password"
                  spellcheck="false"
                  password-reveal
                  required
                >
                </b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              slim
              rules="required|between:6,30"
              name="New Password"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="New password"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="[
                  errors[0],
                  'The password should be minimum <b>six characters</b> length, contain <b>one capital letter</b> and <b>one number</b> (+ an elfic character from an old spell book)',
                ]"
              >
                <b-input
                  v-model="passwords.password"
                  type="password"
                  autocomplete="new-password"
                  name="new-password"
                  spellcheck="false"
                  password-reveal
                  required
                >
                </b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              slim
              rules="required|confirmed:New Password"
              name="New Password confirmation"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="New password confirmation"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-input
                  v-model="passwords.password_confirmation"
                  type="password"
                  autocomplete="new-password"
                  name="new-password-confirmation"
                  spellcheck="false"
                  password-reveal
                  required
                >
                </b-input>
              </b-field>
            </ValidationProvider>
            <b-button type="is-success" @click="handleSubmit(changePassword)"
              >Change password</b-button
            >
          </div>
        </ValidationObserver>
      </div>

      <!-- <div class="column is-8">
        <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Current Session</h1>
          <p>You are currently logged in from:</p>
          <p>
            <span class="has-text-weight-semibold">Belgium</span> using
            <span class="has-text-weight-semibold">Chrome on Linux</span>
          </p>
          <div class="pt-2 pb-4">
            <b-button type="is-success">Log out</b-button>
          </div>
          <h1 class="has-text-weight-semibold is-size-4">Other Sessions</h1>
          <p class="pb-2">You are also logged in on the following devices:</p>

          <div class="columns">
            <div class="column">
              <b-table
                :data="isEmpty ? [] : data"
                :bordered="true"
                :narrowed="true"
                :mobile-cards="true"
              >
                <b-table-column field="device" label="Device" v-slot="props">
                  {{ props.row.device }}
                </b-table-column>

                <b-table-column field="last_seen" label="Last seen" v-slot="props">
                  {{ props.row.last_seen }}
                </b-table-column>
                <b-table-column label="Log out">
                  <b-button type="is-success">Log out</b-button>
                </b-table-column>
              </b-table>
            </div>
          </div>
          <p class="pb-2">
            You can also log out of all active sessions using the button below:
          </p>
          <b-button type="is-success">Log out of All Sessions</b-button>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { notificationMixin } from '@/mixins/notificationMixin'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mixins: [notificationMixin],
  data () {
    const data = [
      {
        device: 'Chrome on Linux',
        last_seen: 'About 2 weeks ago'
      },
      {
        device: 'Chrome on Windows',
        last_seen: 'About 3 weeks ago'
      }
    ]

    return {
      data,
      isEmpty: false,
      passwords: {
        old_password: null,
        password: null,
        password_confirmation: null
      }
    }
  },
  methods: {
    changePassword () {
      this.$store
        .dispatch('users/passwords/update', this.passwords)
        .then((resp) => {
          this.actionSuccess('Your password has been updated !')
          console.log(resp)
        })
        .catch((error) => {
          this.actionFailure('Something went wrong')
          console.log(error.response)
        })
    }
  }
}
</script>
